import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Menu, SelectTrigger } from "@activecollab/components";
import PropTypes from "prop-types";
import { toDecimal } from "~/utils/utils.jsx";
import { SelectTaskEstimate } from "./tasks/TaskOptions/Submenus/SelectTaskEstimate.jsx";
import TimeEstimateAsLabelContainer from "./time_estimate_as_label/container.time_estimate_as_label.jsx";

const SelectTimeEstimate = ({ estimate, jobTypeId, onChange, disabled, target, isSplit }) => {
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);

  const getTimeEstimateAsLabel = useMemo(() => {
    if (toDecimal(estimate) > 0 && jobTypeId) {
      return (
        <TimeEstimateAsLabelContainer
          value={estimate}
          id={jobTypeId}
        />
      );
    }
    if (disabled) {
      return <span>{t("Not Set")}</span>;
    }
    return null;
  }, [disabled, estimate, jobTypeId, t]);

  const handleShowForm = useCallback(() => {
    setShowForm(true);
  }, []);

  const handleCloseForm = useCallback(() => {
    setShowForm(false);
  }, []);

  const handleChange = useCallback(
    (values) => {
      onChange(values);
      handleCloseForm();
    },
    [onChange, handleCloseForm]
  );

  return !disabled ? (
    <Menu
      target={
        target ? (
          target
        ) : (
          <SelectTrigger
            className="tw-w-full"
            typographyProps={{
              color: getTimeEstimateAsLabel ? "primary" : "quaternary",
            }}
          >
            {getTimeEstimateAsLabel ?? `${t("Set")}...`}
          </SelectTrigger>
        )
      }
      open={showForm}
      onOpen={handleShowForm}
      onClose={handleCloseForm}
      menuClassName="time_estimate_form_wrapper"
    >
      <SelectTaskEstimate
        estimate={estimate}
        jobTypeId={jobTypeId}
        onCancel={handleCloseForm}
        onEscape={handleCloseForm}
        onChange={handleChange}
        isSplit={isSplit}
      />
    </Menu>
  ) : (
    <span
      data-testid="disabled-time-estimate-value"
      className="slim_control disabled"
    >
      <span className="slim_control_label">{getTimeEstimateAsLabel}</span>
    </span>
  );
};

SelectTimeEstimate.propTypes = {
  estimate: PropTypes.string,
  jobTypeId: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  target: PropTypes.object,
  isSplit: PropTypes.bool,
};

SelectTimeEstimate.defaultProps = {
  estimate: ``,
  jobTypeId: 0,
  disabled: false,
};

export default SelectTimeEstimate;
